import React from 'react';
import type { Card } from '@ctd/agent-contract';
import { BreakdownCard } from './breakdown-card';
import { BreakdownComparisonCard } from './breakdown-comparison-card';
import { ComparisonCard } from './comparison-card';
import { ReportCard } from './report-card';
import { SeriesCard } from './series-card';
import { ValueCard } from './value-card';

/** A result card, drawn from its shape alone. */
export const AgentCard: React.FC<{ card: Card }> = ({ card }) => {
    switch (card.shape) {
        case 'value':
            return <ValueCard card={card} />;
        case 'comparison':
            return <ComparisonCard card={card} />;
        case 'breakdown':
            return <BreakdownCard card={card} />;
        case 'breakdown_comparison':
            return <BreakdownComparisonCard card={card} />;
        case 'series':
            return <SeriesCard card={card} />;
        case 'report':
            return <ReportCard card={card} />;
        case 'choices':
            return null;
    }
};
